import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import CardUI from '../../../widgets/layout/CardUI'

import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SoaTxnDescUpdateModalSF from '../../../components/superUser/transaction/SoaTxnDescUpdateModalSF'

const SOAPageUI = ({ context, errorList, account, accountStatementList, onSoaDownloadClick, onSoaPdfDownloadClick, onRefreshClick,
    selectedTxn, updateDescMode, onUpdateDescClick, onUpdateDescCancel
}) =>
    <SuperUserAccountPageUI context={context} className='pg_su_a_props' backLink='/su/accounts' dimension='w1600'
        headerText='SOA' centered={!accountStatementList && !errorList} account={account} updateMode={false}
        onRefreshClick={onRefreshClick}
        page='soa'
    >
        {(!accountStatementList && !errorList) && <SpinnerComponentUI />}
        {errorList && errorList.length > 0 && <GenericErrorUI error={errorList[0]} />}

        {accountStatementList && accountStatementList.length > 0 && (
            <>
                <LRTableActionsUI
                    location='top'
                    left={
                        <span className='g_flex_left g_flex_h'>
                            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                            <IconButtonUI icon="icon-download" onClick={onSoaDownloadClick} label='Excel' />
                            <IconButtonUI icon="icon-download" onClick={onSoaPdfDownloadClick} label='PDF' />
                            <span className='g_m_left_100 g_large'><b>Account Statements</b></span>
                        </span>
                    }
                />
                <>
                    <table border={1} style={{ borderCollapse: 'collapse', width: '100%' }}>
                        <thead className='g_sticky'>
                            <tr>
                                <th>Transaction Date</th>
                                <th>Description</th>
                                <th>LRN</th>
                                <th>Dr Amount</th>
                                <th>Cr Amount</th>
                                <th>Escrow Balance</th>
                                <th>Excess Amount</th>
                                <th>DSRA Current</th>
                                <th>DSRA Required</th>
                                <th>OS Principal</th>
                                <th>OS Loan</th>
                                <th>OS Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            {accountStatementList.map((record, index) => (

                                record.transactionType !== 'soa' && (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : '' }}>

                                        <td style={{ textAlign: 'center' }}>{record.transactionDateISO}</td>
                                        <td style={{ textAlign: 'left', paddingLeft: '10px' }}>
                                            {record.description}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>{record.lrn}</td>
                                        <td style={{ textAlign: 'right', paddingRight: '10px', paddingLeft: '5px' }}>{record.drAmountF2}</td>
                                        <td style={{ textAlign: 'right', paddingRight: '10px', paddingLeft: '5px' }}>{record.crAmountF2}</td>
                                        <td style={{ textAlign: 'right', paddingRight: '10px', paddingLeft: '5px' }}>{record.escrowBalanceF2}</td>
                                        <td style={{ textAlign: 'right', paddingRight: '10px', paddingLeft: '5px' }}>{record.excessAmountF2}</td>
                                        <td style={{ textAlign: 'right', paddingRight: '10px', paddingLeft: '5px' }}>{record.dsraCurrentF2}</td>
                                        <td style={{ textAlign: 'right', paddingRight: '10px', paddingLeft: '5px' }}>{record.dsraTotalF2}</td>
                                        <td style={{ textAlign: 'right', paddingRight: '10px', paddingLeft: '5px' }}>{record.osPrincipalF2}</td>
                                        <td style={{ textAlign: 'right', paddingRight: '10px', paddingLeft: '5px' }}>{record.osLoanF2}</td>
                                        <td style={{ textAlign: 'right', paddingRight: '10px', paddingLeft: '5px' }}>{record.osBalanceF2}</td>
                                        <td>
                                            <span className='icon icon-pencil g_muted g_m_left_50' onClick={onUpdateDescClick} data-id={record.transactionId} />
                                        </td>
                                    </tr>
                                )
                            ))}
                        </tbody>
                    </table>
                </>
            </>
        )
        }
        {
            accountStatementList && accountStatementList.length === 0 &&
            <>
                <LRTableActionsUI
                    location='top'
                    left={
                        <span className='g_flex_left g_flex_h'>
                            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                            <span className='g_m_left_100 g_large'><b>Account Statements</b></span>
                        </span>
                    }
                />
                <EmptyListUI context={context} createEnabled={false} createDisabledMessageLabel='No Account Statement Records' />
            </>
        }

        <SoaTxnDescUpdateModalSF context={context} account={account} selectedTxn={selectedTxn}
            onRefreshClick={onRefreshClick} updateMode={updateDescMode} onCancelClick={onUpdateDescCancel} />
    </SuperUserAccountPageUI >

export default SOAPageUI
